export const setSessionFlowSegment = (context) => (session, segment) => ({
    type: "MEETING.SESSION.SET_FLOW_SEGMENT",
    payload: {
        session,
        segment,
    },
    context,
});
